import { render, staticRenderFns } from "./OurApps.vue?vue&type=template&id=037a35e0&scoped=true&"
import script from "./OurApps.vue?vue&type=script&lang=js&"
export * from "./OurApps.vue?vue&type=script&lang=js&"
import style0 from "./OurApps.vue?vue&type=style&index=0&id=037a35e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037a35e0",
  null
  
)

export default component.exports